import { render, staticRenderFns } from "./EarningOrLost.vue?vue&type=template&id=bf91a520&scoped=true&"
import script from "./EarningOrLost.vue?vue&type=script&lang=js&"
export * from "./EarningOrLost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf91a520",
  null
  
)

export default component.exports